"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fragments_1 = require("../fragments");
const notifi_axios_utils_1 = require("@notifi-network/notifi-axios-utils");
const DEPENDENCIES = [...fragments_1.sourceGroupFragmentDependencies, fragments_1.sourceGroupFragment];
const MUTATION = `
mutation createSourceGroup(
  $name: String!
  $sourceIds: [String!]!
) {
  createSourceGroup(
    sourceGroupInput: {
      name: $name
      sourceIds: $sourceIds
    }
  ) {
    ...sourceGroupFragment
  }
}
`.trim();
const createSourceGroupImpl = (0, notifi_axios_utils_1.makeRequest)((0, notifi_axios_utils_1.collectDependencies)(...DEPENDENCIES, MUTATION), 'createSourceGroup');
exports.default = createSourceGroupImpl;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3JlYXRlU291cmNlR3JvdXBJbXBsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vbGliL211dGF0aW9ucy9jcmVhdGVTb3VyY2VHcm91cEltcGwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSw0Q0FHc0I7QUFDdEIsMkVBRzRDO0FBTTVDLE1BQU0sWUFBWSxHQUFHLENBQUMsR0FBRywyQ0FBK0IsRUFBRSwrQkFBbUIsQ0FBQyxDQUFDO0FBRS9FLE1BQU0sUUFBUSxHQUFHOzs7Ozs7Ozs7Ozs7OztDQWNoQixDQUFDLElBQUksRUFBRSxDQUFDO0FBRVQsTUFBTSxxQkFBcUIsR0FBRyxJQUFBLGdDQUFXLEVBR3ZDLElBQUEsd0NBQW1CLEVBQUMsR0FBRyxZQUFZLEVBQUUsUUFBUSxDQUFDLEVBQUUsbUJBQW1CLENBQUMsQ0FBQztBQUV2RSxrQkFBZSxxQkFBcUIsQ0FBQyJ9